// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"959":"a4526119","2066":"830880fa","2104":"17006f36","2548":"6828c926","2637":"d080cdcf","3417":"e6ed89ee","5905":"812c2c04","5961":"d080cdcf","5991":"2c2803ce","6399":"1c9b63a4","8950":"d080cdcf"}[chunkId] + ".chunk.css";
};